import React, { forwardRef } from 'react'
import styles from './Advertisment.module.scss'
import Container from 'react-bootstrap/Container'
import { FiX } from 'react-icons/fi'
const Advertisment = forwardRef(({ closeAd, adBannerData, imageLoaded }, ref) => {
  const handleCloseAd = () => {
    closeAd(true)
  }
  const handleImageLoaded = () => {
    imageLoaded()
  }


  return (
    <>
      {adBannerData?.url ? (
        <div className={`${styles.advertisement_wrp} secAnim`} ref={ref}>
          <span className={styles.close} onClick={() => handleCloseAd()}>
            <FiX />
          </span>
          <Container>
            <a href={adBannerData?.link} target="_blank" rel="noreferrer">
              <figure>
                <img src={adBannerData?.url} alt=""
                  onLoad={handleImageLoaded}
                />
              </figure>
            </a>
          </Container>
        </div>
      ) : null}
    </>
  )
})

export default Advertisment
